module.exports = __webpack_public_path__ + "img/nanxiang@2x.2cd91dfb.png";